<template>
  <section class="developer-login-section">
    <div class="container">
      <div class="column-wrapper">
        <div class="column content-column">
          <div class="inner-column">
            <h1>
              Ga aan de slag met de <span class="highlight">toekomstbestendigheid</span> van jouw
              organisatie.
            </h1>
          </div>
        </div>
        <div class="column login-form">
          <div class="inner-column">
            <div class="login-form-top">
              <v-Icon class="logo" name="logo" />
            </div>
            <div class="login-form">
              <div class="inner-form">
                <div class="title-wrapper">
                  <h2 class="column-title">Developer login</h2>
                  <p class="column-subtitle">Voer jouw gegevens in om in te loggen</p>
                </div>

                <UnderConstructionLogin />
              </div>
            </div>
            <div class="login-form-bottom">
              <p>© {{ new Date().getFullYear() }} Future Proof Scan</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button class="develop-login-btn" @click="loginWithClick()"></button>
  </section>
</template>

<script>
//Vue
import { defineComponent, ref } from 'vue'

//Components
import UnderConstructionLogin from '@/components/Forms/UnderConstructionLogin.vue'

import { useGlobalStore } from '@/stores/global'

export default defineComponent({
  components: {
    UnderConstructionLogin
  },
  setup() {
    const activeDeveloperLogin = ref(false)

    const globalStore = useGlobalStore()

    const showDeveloperLogin = () => {
      activeDeveloperLogin.value = true
    }

    const closeDeveloperLogin = () => {
      activeDeveloperLogin.value = false
    }

    function loginWithClick() {
      globalStore.removeUnderConstruction();

      //24h validated
      setCookie('under-construction-validated', 'yes', 1)
    }

    function setCookie(cname, cvalue, exdays) {
      const d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      let expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    }

    return {
      activeDeveloperLogin,
      showDeveloperLogin,
      closeDeveloperLogin,
      loginWithClick
    }
  }
})
</script>

<style lang="scss" scoped>
// @import styles
@import './index.scss';
</style>
